export default __webpack_public_path__ + "static/media/00.997c36a4.jpg";